import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

interface Props {
  options: OptionProps[]
}

interface OptionProps {
  title: string
  type: string
  selected?: boolean
  onClick?(): any
}

const SelectablePillNew = ({ options }: Props) => {
  return (
    <PillContainer>
      {options.map(({ title, type, selected, onClick }, index) => (
        <OptionContainer
          className={`option-${index} ${selected ? 'selected' : ''}`}
          onClick={onClick}
          key={`${type}-button`}
          data-testid={`${type}-button`}
        >
          <label htmlFor={title}>
            <Title>{title}</Title>
          </label>
        </OptionContainer>
      ))}
    </PillContainer>
  )
}

const PillContainer = styled.div<StyledHTMLElement>(
  ({ theme }): CSSObject => ({
    display: 'flex',
    position: 'relative',
    flexGrow: 1,
    backgroundColor: '#f5f5f5',
    borderRadius: theme.borderRadius,
    height: '46px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  })
)

const OptionContainer = styled.div<StyledHTMLElement & { className: string }>(
  ({ theme, className }) => ({
    display: 'flex',
    width: '50%',
    borderRadius: theme.borderRadius,
    height: '54px',
    transition: 'border-color 200ms ease-in-out',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',

    '& label': {
      zIndex: 2,
      cursor: 'pointer'
    },

    ':after': {
      background: `${className ? theme.colors['primary'] : '#f5f5f5'}`,
      content: '""',
      height: '100%',
      position: 'absolute',
      top: 0,
      transition: 'left 200ms cubic-bezier(0.77, 0, 0.175, 1)',
      width: '50%',
      borderRadius: theme.borderRadius,
      zIndex: 1
    },

    '&.option-0': {
      ':after': {
        display: 'none'
      }
    },
    '&.option-1': {
      ':after': {
        left: 0
      }
    },

    '&.selected': {
      transition: 'color 200ms',
      color: `${className ? theme.colors['white'] : null}`,
      '&.option-1': {
        ':after': {
          left: '50%'
        }
      }
    }
  })
)

const Title = styled.h2<StyledHTMLElement>(({ theme }) => ({
  fontSize: theme.fontSizes[2]
}))

export default SelectablePillNew
